// Shared cookie configuration for the persisted auth store.
//
// Must stay relative (maxAge), never absolute (expires): the persist plugin calls
// cookiesWithOptions() once and keeps these options in a closure, so an absolute Date
// would be frozen at module evaluation — which in the Nitro server process means
// "server boot + n days" instead of "login + n days". Once that date passes, Nuxt's
// useCookie returns undefined even though the cookie is present in the request, the
// store never hydrates during SSR and every reload redirects to /login.
export const AUTH_COOKIE_NAME = 'auth';

// 400 days is the hard cap Chrome and Firefox apply to any cookie. The Nitro middleware
// in server/middleware/auth-cookie-refresh.js re-stamps it on every request, so the
// window only runs out after 400 days without a single visit.
export const AUTH_COOKIE_MAX_AGE = 60 * 60 * 24 * 400;

// Note: `secure` follows the dev flag, so a production build served locally over plain
// http://localhost will not store the cookie in a browser. Use `npm run dev` for local
// browser testing; curl against `npm run start` is unaffected.
export function getAuthCookieOptions() {
  return {
    path: '/',
    sameSite: 'strict',
    secure: !import.meta.dev,
    maxAge: AUTH_COOKIE_MAX_AGE,
  };
}
